module.exports = __webpack_public_path__ + "static/media/Item 14.0d845230.jpg";